import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/_main.scss'
import { createPinia } from 'pinia'
import { SimpleSVG } from 'vue3-simple-svg'

import DefaultButton from './components/ui/DefaultButton.vue'
import ImageButton from './components/ui/ImageButton.vue'
import VInput from './components/ui/VInput.vue'
import VCheckButton from './components/ui/VCheckButton.vue'
import VRadioButton from './components/ui/VRadioButton.vue'
import VSelect from './components/ui/VSelect.vue'
import VPopup from './components/ui/VPopup.vue'
import SearchInput from './components/ui/SearchInput.vue'
import VDateTime from './components/ui/VDateTime.vue'
import BackButton from './components/ui/BackButton.vue'

createApp(App)
    .component('simple-svg', SimpleSVG)
    .component('default-button', DefaultButton)
    .component('image-button', ImageButton)
    .component('back-button', BackButton)
    .component('v-input', VInput)
    .component('v-select', VSelect)
    .component('v-datetime', VDateTime)
    .component('v-popup', VPopup)
    .component('search-input', SearchInput)
    .component('v-check-button', VCheckButton)
    .component('v-radio-button', VRadioButton)
    .use(router)
    .use(createPinia())
    .mount('#app')
